// src/api/queryClient.ts
import { QueryClient } from '@tanstack/react-query';

//? Decisão 16 do Orval: sem cache — toda tela busca de novo ao abrir, como o useEffect de antes.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
